/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConfirmIcon } from '../../../components/widgets/confirm-button';
import { t } from '../../../locales/i18n';
import { Icon } from '../../../components/icon';
import { QueueStatus } from './queue-status';
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Input } from 'semantic-ui-react';
import { Queue } from '../../../types/queue';
import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';
import { colors } from '@nextinq/ui-toolkit';
import { Segment } from '../../../components/segment';
import { InputWrapper } from '../../../components/forms/input-wrapper';
import { queueSettingsPath } from '../../../navigation';

const Container = styled.section`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    'name actions'
    'status actions';
`;
const Name = styled.h3`
  grid-area: name;
`;
const Status = styled.section`
  grid-area: status;
`;
const Actions = styled.section`
  grid-area: actions;
  display: grid;
  align-items: center;
  justify-items: center;
  i {
    font-size: ${sizes.fonts.large};
    color: ${colors.grey.grey};
  }
`;

export interface QueueHeaderProps {
  queue: Queue;
  onAppendTicket: (ticketNote: string) => void;
}

export function QueueHeader(props: QueueHeaderProps) {
  const { queue } = props;
  const { device_uuid } = useParams<{ device_uuid: string }>();

  const queueSettingsLink = queueSettingsPath(device_uuid || '', queue.id);
  const [ticketNote, setTicketNote] = useState('');
  if (!queue) {
    return null;
  }
  return (
    <Segment primary padding="large">
      <Container>
        <Name>
          {queue.ticketPrefix} {queue.name}
        </Name>
        <Status>
          <QueueStatus {...props} />
        </Status>
        <Actions>
          <Link to={queueSettingsLink}>
            <Icon name="setting" />
          </Link>
          <ConfirmIcon
            iconName="add"
            onConfirm={() => {
              props.onAppendTicket(ticketNote);
              setTicketNote('');
            }}
            title={t('addTicket.title')}
            subtitle={t('addTicket.subtitle')}
            primary
          >
            <InputWrapper helperText={t('queueHeader.ticketNote.hintText')}>
              <Input
                maxLength={20}
                onChange={(e) =>
                  console.log('changed', setTicketNote(e.target.value))
                }
                value={ticketNote || ''}
              />
            </InputWrapper>
          </ConfirmIcon>
        </Actions>
      </Container>
    </Segment>
  );
}
